import { COLOURS } from '../constants/colours';

// utils
import { sortByProperty } from '../utils/general'

export const getUserId = () => {
    const authToken = JSON.parse(localStorage.getItem('okta-token-storage'));
    return authToken?.accessToken?.claims.uid;
}

export const getLoggedInUserEmail = () => {
    const authToken = JSON.parse(localStorage.getItem('okta-token-storage'));
    return authToken?.accessToken?.claims.sub;
}

export const getApplications = () => {
    const authToken = JSON.parse(localStorage.getItem('okta-token-storage'))
    const groups = authToken?.accessToken?.claims?.groups || [];
    const adminApplications = []
    const superAdminApplications = []
    groups.forEach((group) => {
        const [application, role] = group.split('-') || [];
        if (role?.toLowerCase().trim() === 'admin') adminApplications.push(application.trim())
        if (role?.toLowerCase().trim() === 'super admin') superAdminApplications.push(application.trim());
    })
    return { adminApplications, superAdminApplications }
}

export const getAdminApplications = () => {
    const { adminApplications } = getApplications();
    return adminApplications;
}

export const isSuperAdmin = () => {
    const { superAdminApplications } = getApplications()
    if (superAdminApplications?.length > 0) return true;
    return false;
}

export const isAdmin = () => {
    const { adminApplications } = getApplications()
    if (adminApplications?.length > 0) return true;
    return false;
}

export const getRoleDisplayName = () => {
    if (isSuperAdmin()) return 'Super Admin';
    if (isAdmin()) return 'Admin';
    return '';
}

const getGroupWithColour = (applicationsColourMap, colourIndex) => (group) => {
    const [application] = group.display.split('-') || [];
    const colour = applicationsColourMap[application];
    if (colour) {
        group.colour = colour;
        return group;
    }
    const newColour = COLOURS[colourIndex++]
    applicationsColourMap[application] = newColour;
    group.colour = newColour;
    return group;
}

export const getGroupsWithColour = (groups) => {
    const applicationsColourMap = {};
    const colourIndex = 0;
    const sortedGroups = sortByProperty(groups, 'display')
    const groupsWithColour =
    sortedGroups.map(getGroupWithColour(applicationsColourMap, colourIndex))
    return groupsWithColour;
}

export const getApplicationsRoles = () => {
    const authToken = JSON.parse(localStorage.getItem('okta-token-storage'))
    const groups = authToken?.accessToken?.claims?.groups || [];
    return { groups }
}

export const isReviewer = () => {
    const authToken = JSON.parse(localStorage.getItem('okta-token-storage'))
    const groups = authToken?.accessToken?.claims?.groups || [];
    return groups.includes('xIAM API Gateway - Access Reviewer')
}
